import { createAction } from '@reduxjs/toolkit';
import { validatePayload } from '../../utils/validate-payload.js';
import { makeAnalyticsAction, } from '../analytics/analytics-utils.js';
import { staticFilterIdSchema, staticFilterValueSchema, staticFilterValuesSchema, } from './static-filter-set-schema.js';
export const registerStaticFilter = createAction('staticFilter/register', (payload) => {
    const schema = {
        id: staticFilterIdSchema,
        values: staticFilterValuesSchema,
    };
    return validatePayload(payload, schema);
});
export const toggleSelectStaticFilterValue = createAction('staticFilter/toggleSelect', (payload) => {
    const schema = {
        id: staticFilterIdSchema,
        value: staticFilterValueSchema,
    };
    return validatePayload(payload, schema);
});
export const toggleExcludeStaticFilterValue = createAction('staticFilter/toggleExclude', (payload) => {
    const schema = {
        id: staticFilterIdSchema,
        value: staticFilterValueSchema,
    };
    return validatePayload(payload, schema);
});
export const deselectAllStaticFilterValues = createAction('staticFilter/deselectAllFilterValues', (payload) => {
    return validatePayload(payload, staticFilterIdSchema);
});
//TODO: KIT-2859
export const logStaticFilterSelect = (metadata) => makeAnalyticsAction('analytics/staticFilter/select', (client) => client.makeStaticFilterSelect(metadata));
//TODO: KIT-2859
export const logStaticFilterDeselect = (metadata) => makeAnalyticsAction('analytics/staticFilter/deselect', (client) => client.makeStaticFilterDeselect(metadata));
//TODO: KIT-2859
export const logStaticFilterClearAll = (metadata) => makeAnalyticsAction('analytics/staticFilter/clearAll', (client) => client.makeStaticFilterClearAll(metadata));
// --------------------- KIT-2859 : Everything above this will get deleted ! :) ---------------------
